import { render, staticRenderFns } from "./BDXStatusModalFormFCPToggleDateModal.vue?vue&type=template&id=047b8876"
import script from "./BDXStatusModalFormFCPToggleDateModal.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalFormFCPToggleDateModal.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusModalFormFCPToggleDateModal.vue?vue&type=style&index=0&id=047b8876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports